<template>
  <div class="div-main-list-page-table">
    <div class="header">
      <span class="title">Import Excel Log</span>
      <el-button
        style="min-width: 100px"
        outline
        size="mini"
        round
        @click="$emit('close', (noAction = true))"
      >
        Close
      </el-button>
    </div>
    <div
      class="table-block margin-top-0"
      :style="{ height: isFilterVisit ? 'calc(100% - 150px)' : 'calc(100% - 74px)' }"
    >
      <el-table
        ref="excelLogTable"
        :data="logData"
        height="100%"
        :border="true"
        :header-cell-style="HEADER_CELL_STYLE"
        :cell-style="CELL_STYLE"
        :empty-text="'No data found'"
      >
        <el-table-column prop="createdAt" label="Date Imported" width="150">
          <template slot-scope="scope">
            <div>{{ scope.row.createdAt ? formatDateTime(new Date(scope.row.createdAt)) : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="updatedBy" label="Updated By" width="150"></el-table-column>
        <el-table-column prop="jobId" label="Job Id" width="200"></el-table-column>
        <el-table-column prop="referenceNo" label="Reference No." width="150"></el-table-column>
        <el-table-column prop="type" label="Action" width="100">
          <template v-slot="scope">
            <span>
              {{ scope.row.type === "1" ? "Insert" : 
                scope.row.type === "2" ? "Insert" : 
                scope.row.type === "3" ? "Update" : 
                scope.row.type === "4" ? "Cancel" : scope.row.type }} Job
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="excjob" label="Excel Job" width="600"></el-table-column>
      </el-table>
    </div>
    <div class="div-main-list-page-table-pagination">
      <el-pagination
        background
        @size-change="handleJobPageSizeChange"
        @current-change="handleJobPageChange"
        :page-size.sync="pageParam.pageSize"
        :page-sizes="[5, 10, 20, 50, 100]"
        :current-page="pageParam.pageNumber"
        :layout="paginationSetting"
        :total="logTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { HEADER_CELL_STYLE, CELL_STYLE } from "@/constants.js";
import { getImportExcelLogList } from "@/services/modules/ops.js";
import { serverSGDateTimeFormat  } from "@/utils";
import moment from 'moment'

export default {
  name: "ImportExcelLog",
  data() {
    return {
      HEADER_CELL_STYLE,
      CELL_STYLE,
      pageParam: {
        pageSize: 20,
        pageNum: 1,
      },
      logData: [],
      logTotal: 0,
    };
  },
  computed: {
    ...mapState({
      currentCompany: "currentCompany",
      isMobileScreen: "isMobileScreen",
      isVictory: "isVictory",
    }),
    paginationSetting(){
      return this.isMobileScreen?"total,prev, pager, next":"total, sizes, prev, pager, next, jumper"
    }
  },
  watch: {
    // locationList() {
    //   this.cascaderKey++;
    // },
  },
  created() {
    this.getImportExcelLog()
  },
  methods: {
    serverSGDateTimeFormat,
    formatDateTime(date,format = 'YYYY-MM-DD HH:mm:ss'){
      return moment(date).format(format)
    },
    getImportExcelLog(){
      getImportExcelLogList(this.pageParam.pageSize, this.pageParam.pageNum).then(res => {
        if (res.code === 1000){
          this.logData = res.data.records
          this.logTotal = res.data.total
        }
      })
    },
    handleJobSelectionChange(val) {
      this.$emit("handleJobSelectionChange", val);
    },
    handleJobPageSizeChange(pageSize) {
      this.pageParam.pageSize = pageSize
      this.getImportExcelLog()
    },
    handleJobPageChange(pageNumber) {
      this.pageParam.pageNum = pageNumber
      this.getImportExcelLog()
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.title {
  // font-size: 18px;
  font-weight: bold;
}
</style>
